import { GET_DETAILSUBVENDOR_REQUESTED, GET_SUBADDVENDOR_REQUESTED, GET_SUBVENDOR_REQUESTED, UPDATE_SUBADDVENDOR_REQUESTED } from "resources/actionTypes";

export function getSubVendor(data) {
  return {
    type: GET_SUBVENDOR_REQUESTED,
    payload: data,
  };
}

export function postAddSubVendor(userAddSubVendor) {
  const data ={
    userAddSubVendor:userAddSubVendor,
  }
  return {
    type: GET_SUBADDVENDOR_REQUESTED,
    payload: data,
  };
}

export function patchUpdateSubVendor(userUpdateSubVendor) {
  const data ={
    userUpdateSubVendor:userUpdateSubVendor,
  }
  return {
    type: UPDATE_SUBADDVENDOR_REQUESTED,
    payload: data,
  };
}

export function getDetailSubVendor(data) {
  return {
    type: GET_DETAILSUBVENDOR_REQUESTED,
    payload: data,
  };
}
